export const ActionType = {
  OPEN_RESORT_MODAL: 'OPEN_RESORT_MODAL',
  CLOSE_RESORT_MODAL: 'CLOSE_RESORT_MODAL',
  OPEN_DRAW_INSTRUMENTS: 'OPEN_DRAW_INSTRUMENTS',
  CLOSE_DRAW_INSTRUMENTS: 'CLOSE_DRAW_INSTRUMENTS',
};
